
















































































import { TransceiverService } from '@/services/transceiver-service';
import { ClassicRawDataType, ChimeraRawDataType } from './raw-data-utils';
import { Watch, Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { TransceiverRawData } from '@/api';
import moment from 'moment';
import Toast from '../toast.vue';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

@Component({
	components:{ VueCtkDateTimePicker }
})

export default class RawDataTable extends Vue {
	// Props
	@Prop({ type: String })
	public type!: ChimeraRawDataType | ClassicRawDataType;
	@Prop({ type: Number })
	public transceiverId?: number;
	@Prop({ type: Boolean })
	public isClassic?: boolean;
	@Prop({ type: String, default: "" })
	public filter!: string;

	// Data Fields
	public api: TransceiverService = new TransceiverService();
	public loading = true;
	public rawData: TransceiverRawData[] = [];

	public rawDataFields: any[] | null = [
		{ key: 'receivedTS', label: 'Received' },
		{ key: 'data', label: 'Data' },
		{ key: 'topic', label: 'Topic' },
	];

	// Date Picker Fields
	public readonly DEFAULT_DAY_COUNT = 1;
	public format = 'DD-MM-YYYY HH:mm:ss';
	public minDate = moment()
		.subtract(30, 'days')
		.format('YYYY-MM-DD');

	public form = {
		start: moment()
			.subtract(1, 'days')
			.locale('en-nz')
			.startOf('day')
			.format(this.format),
		end: moment()
			.locale('en-nz')
			.endOf('day')
			.format(this.format),
	};

	public toast = new Toast();

    public get computedFilter(): string {
        return this.filter;
    }

    public set computedFilter(value: string) {
        this.updateFilter(value);
    }

	public updateForm() {
		this.load();
	}

	@Emit('update:filter')
	public updateFilter(value: string) {

		return value;
	}

	public getFilters() {
        let filters: any = {};

		// Filtering can be done by type or search or both. Chimera and classic use slightly different formatting
		// for their filters. Classic uses multiple dataFilters and Chimera uses a typeFilter and dataFilters. We 
		// check, in order, type and filter being defined, just filter being defined, and then just type being defined.

		if(this.isClassic) {
			if (this.type != 'all' && this.filter != '') {
				filters.dataFilters = [this.type, this.filter];
			} else if (this.type == 'all' && this.filter != '') {
				filters.dataFilters = [this.filter];
			} else if (this.type != 'all' && this.filter == '') {
				filters.dataFilters = [this.type];
			}
		} else {
			if (this.type != 'all' && this.filter != '') {
				filters.typeFilter = this.type;
				filters.dataFilters = [this.filter];
			} else if (this.type == 'all' && this.filter != '') {
				filters.dataFilters = [this.filter];
			} else if (this.type != 'all' && this.filter == '') {
				filters.typeFilter = this.type;
			}
		}

        return filters;
    }

	@Watch('filter')
	public async load() {
		if (this.transceiverId != null) {
			this.loading = true;

			const { rawData, errorMessage } = await this.api.getRawData(this.transceiverId, {
				...this.getFilters(),
				startTs: moment(this.form.start, this.format).unix(),
				endTs: moment(this.form.end, this.format).unix(),
				sortAsc: false,
			});

			if (rawData) {
				this.rawData = rawData;
			} else if (errorMessage) {
				this.rawData = [];
				this.toast.makeToast(errorMessage, 'Raw Data Error', 'danger');
			}

			this.loading = false;
		}
	}

	public mounted() {
		if(this.type == "all") {
			this.updateFilter("");
		}
		this.load();
	}
}
